import React from 'react';
import { Log } from 'ng2-logger';
import { ShowAllButtonProps } from '../../models/components/show-all-button';
import { Link } from 'react-router-dom';
import Translator from '../../core/i18n';

const _logger = Log.create('show-all-button.tsx');
const T = Translator.create();

const ShowAllButton = (props: ShowAllButtonProps) => {

    return (
        <Link className='new_btn btn_tertiary small'
            to={window.appSettings.DEFAULT_URL + props.redirectUrl}>{T.t('r_menu_course_allOf')}
            <i className="material-icons ml-1 align-middle" style={{ fontSize: "15px", color: "#646462", marginBottom: "3px" }}>
                arrow_forward
            </i>
        </Link>
    );
}

export default ShowAllButton;
